import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Loader from "@mui/material/CircularProgress";

const FEE_MAP_MEMBER = {
  Students: 2500,
  "Postdoc/Young Scientist": 4000,
  "Faculty/Scientist": 7000,
  "Industry person": 10000,
  "Accompanying person": 3000,
  "Students from outside India": 250,
  "Faculty/Scientist from outside India": 400,
};

const FEE_MAP_NON_MEMBER = {
  Students: 3500,
  "Postdoc/Young Scientist": 5000,
  "Faculty/Scientist": 8000,
  "Industry person": 12000,
  "Accompanying person": 3000,
  "Students from outside India": 300,
  "Faculty/Scientist from outside India": 500,
};

const FeePayment = () => {
  const [formData, setFormData] = useState({
    conferenceCategory: "",
    membershipNumber: "",
    registrationCategory: "",
    amount: "",
  });
  const navigate = useNavigate();
  const [isRegistered, setIsRegistered] = useState(false);
  const { data: authUser, isLoading: loadingAuthUser } = useQuery({
    queryKey: ["authUser"],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update formData values
    let updatedData = { ...formData, [name]: value };

    if (name === "registrationCategory") {
      // Determine the selected fee map based on the conference category
      const feeMap =
        formData.conferenceCategory === "IIS member"
          ? FEE_MAP_MEMBER
          : FEE_MAP_NON_MEMBER;

      // Calculate amount if valid registration category is selected
      const selectedAmount = feeMap?.[value];
      if (selectedAmount) {
        updatedData.amount = (selectedAmount * 1.18).toFixed(2); // Add 18% GST
      } else {
        updatedData.amount = ""; // Clear amount if registration category is invalid
      }
    }
    if (name === "conferenceCategory") {
      const feeMap =
        value === "IIS member" ? FEE_MAP_MEMBER : value === "Non-member" ?  FEE_MAP_NON_MEMBER : "";

      if (formData.registrationCategory) {
        const selectedAmount = feeMap?.[formData.registrationCategory];
        if (selectedAmount) {
          updatedData.amount = (selectedAmount * 1.18).toFixed(2);
        } else {
          updatedData.amount = "";
        }
      }
    }

    // Update the state
    setFormData(updatedData);
  };
// Function to get the formatted amount for display
const getFormattedAmount = () => {
  if (!formData.amount) return "";
  const isOutsideIndia =
    formData.registrationCategory?.includes("outside India");
  const currencySymbol = isOutsideIndia ? "$" : "₹";
  
  return `${currencySymbol}${formData.amount}`;
}
  const handlePayment = (e) => {
    e.preventDefault();
    sessionStorage.setItem("paymentDetails", JSON.stringify(formData));
    navigate("/conference-registration/verify-payment");
  };

  if (authUser?.amountPaid) {
    return (
      <div className="p-6 text-center text-green-600 bg-green-100 rounded-md">
        You have successfully paid the fee.
      </div>
    );
  }
  if (loadingAuthUser) {
    return (
      <div className="h-[400px] flex justify-center items-center">
        <Loader sx={() => ({ color: "#4f46e5" })} />
      </div>
    );
  }
  return (
    <form
      onSubmit={handlePayment}
      className="max-w-2xl mx-auto p-6 bg-white rounded-md"
    >
      {/* Fee Details */}
      <fieldset className="mb-6">
        <legend className="text-lg font-semibold mb-2">Fee Details</legend>

        <div className="flex flex-col mb-4">
          <label className="mb-1">Conference Category</label>
          <select
            required
            name="conferenceCategory"
            value={formData.conferenceCategory}
            onChange={handleChange}
            className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-[#4f46e5]"
          >
            <option value="">Select Category</option>
            <option value="IIS member">IIS member</option>
            <option value="Non-member">Non-member</option>
          </select>
        </div>

        <div className="flex flex-col mb-4">
          <label className="mb-1">Membership Number (if applicable)</label>
          <input
            disabled={formData.conferenceCategory !== "IIS member"}
            type="text"
            name="membershipNumber"
            value={formData.membershipNumber}
            onChange={handleChange}
            className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-[#4f46e5]"
          />
        </div>

        <div className="flex flex-col mb-4">
          <label className="mb-1">Registration Category</label>
          <select
            required
            name="registrationCategory"
            value={formData.registrationCategory}
            onChange={handleChange}
            className="border p-2 rounded focus:outline-none focus:ring-2 focus:ring-[#4f46e5]"
            disabled={!formData.conferenceCategory}
          >
            <option value="">Select Registration Category</option>
            <option value="Students">Students</option>
            <option value="Postdoc/Young Scientist">
              Postdoc/Young Scientist
            </option>
            <option value="Faculty/Scientist">Faculty/Scientist</option>
            <option value="Industry person">Industry person</option>
            <option value="Accompanying person">Accompanying person</option>
            <option value="Students from outside India">
              Students from outside India
            </option>
            <option value="Faculty/Scientist from outside India">
              Faculty/Scientist from outside India
            </option>
          </select>
        </div>

        <div className="flex flex-col mb-4">
          <label className="mb-1">Amount (18% GST added)</label>
          <input
            required
            type="text"
            name="amount"
            value={getFormattedAmount()}
            disabled
            className="border p-2 rounded bg-gray-100 focus:outline-none"
          />
        </div>
      </fieldset>

      
        <button
          type="submit"
          className="px-6 py-2 bg-[#4f46e5] text-white rounded-lg hover:bg-[#6a63e9]"
        >
          Continue
        </button>
    </form>
  );
};

export default FeePayment;
